import React, { memo, useCallback, useRef } from "react";
import ScrollBar from "react-custom-scrollbars";

const ScrollContent = ({ children }) => {
  const scrollbarsEl = useRef(null);
  const arrowTopEl = useRef(null);

  const handleScroll = useCallback(() => {
    arrowTopEl.current.style.opacity =
      scrollbarsEl.current.getScrollTop() > 50 ? 1 : 0;
  }, []);

  const top = () => {
    let id = null;

    const scrollTop = () => {
      const currentScrollTop = scrollbarsEl.current.getScrollTop() - 500;
      if (currentScrollTop > 0) {
        scrollbarsEl.current.scrollTop(currentScrollTop);
        id = window.requestAnimationFrame(scrollTop);
      } else {
        scrollbarsEl.current.scrollToTop();
        window.cancelAnimationFrame(id);
      }
    };

    scrollTop();
  };

  return (
    <div className="content scrollarea">
      <div className="scrollarea__inner">
        <ScrollBar
          ref={scrollbarsEl}
          className="scrollarea__content"
          onScroll={handleScroll}
          renderView={({ style, ...props }) => (
            <div style={{ ...style }} {...props} className="scrollarea__view" />
          )}
          renderThumbVertical={({ style, ...props }) => (
            <div
              style={{ ...style }}
              {...props}
              className="scrollarea__thumb"
            />
          )}
        >
          {children}
        </ScrollBar>

        <div
          ref={arrowTopEl}
          className="btn-top"
          role="button"
          aria-label="ScrollUp"
          onClick={top}
        >
          <i className="btn-top__icon ico ico-arrow-top" role="presentation" />
        </div>
      </div>
    </div>
  );
};

export default memo(ScrollContent);
